import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription, filter, switchMap } from 'rxjs';

import { DiscoverHypeService } from '../../services/discover-hype.service';
import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
import { LeftSidebarService } from '../../../../Common/Layout/services/left-sidebar.service';
import { DiscoverLeftSidebarService } from '../../services/discover-left-sidebar.service';
import { SidebarColorThemesEnum } from '../../../../Common/Forms/enums/sidebar-color-themes.enum';
import { CsvImportDialogService } from '../../../../Common/Dialogs/components/CsvImportDialog/csv-import-dialog.service';
import { ContactCsvImportDialogService } from '../../../Targeting/services/contact-csv-import-dialog.service';
import { DiscoverRoutingService } from '../../../DiscoverRouter/services/discover-routing.service';

import { DiscoverRouteTypeEnum } from '../../../DiscoverRouter/enums/discover-route-type.enum';
import { LeftSidebarManagementService } from '../../../../Common/Layout/services/left-sidebar-management.service';
import { DiscoverLeftSidebarManagementService } from '../../services/discover-left-sidebar-management.service';
import { DataConnectionService } from '../../../../Core/Users/services/data-connection.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';

@Component({
    selector: 'agpr-discover',
    templateUrl: './discover.component.html',
    styleUrls: ['./discover.component.scss'],
    providers: [
        {
            provide: AbstractHypeService,
            useClass: DiscoverHypeService
        },
        {
            provide: LeftSidebarService,
            useExisting: DiscoverLeftSidebarService
        },
        {
            provide: CsvImportDialogService,
            useClass: ContactCsvImportDialogService
        },
        {
            provide: LeftSidebarManagementService,
            useExisting: DiscoverLeftSidebarManagementService
        }
    ],
    standalone: false
})
export class DiscoverComponent implements OnDestroy {

    fullWidth: boolean = false;
    subscriptions: Subscription[] = [];

    reAuthIgnored: boolean = false;
    emailAccountReAuthRequired: boolean = false;

    readonly sidebarColorThemesEnum = SidebarColorThemesEnum;
    readonly severityEnum = messageSeverityEnum;
    readonly componentStyle = AgprComponentStyleEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public discoverRoutingService: DiscoverRoutingService,
        private dataConnectionService: DataConnectionService,
        private router: Router,
    ) {
        this.subscriptions.push(
            this.discoverRoutingService.getCurrentRoute().subscribe(route => {
                this.fullWidth = route.type === DiscoverRouteTypeEnum.influencerStreams;
            }),
            this.discoverRoutingService.getCurrentRoute().pipe(
                filter(route => {
                    const reAuthDistributionRoutes = [
                        // Does not include report
                        DiscoverRouteTypeEnum.distributionDashboard,
                        DiscoverRouteTypeEnum.distributionEdit,
                        DiscoverRouteTypeEnum.distributionHype,
                        DiscoverRouteTypeEnum.distributionReport,
                        DiscoverRouteTypeEnum.newDistribution,
                        DiscoverRouteTypeEnum.distributionNew,
                    ];
                    return reAuthDistributionRoutes.includes(route.type);
                }),
                filter(() => !this.reAuthIgnored),
                switchMap(() => this.dataConnectionService.userEmailAccountConnectionsRequireReAuth$)
            ).subscribe(requiresReAuth => {
                this.emailAccountReAuthRequired = requiresReAuth;
            })
        );
    }

    ignoreReAuthToast() {
        this.reAuthIgnored = true;
        this.emailAccountReAuthRequired = false;
    }

    navigateToDataConnectors() {
        this.router.navigate(['DataConnector']);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
